import React from 'react';
import { motion } from 'framer-motion';
export function Welcome() {
  return <section className="bg-white text-zinc-900 py-32 md:py-48 px-6" data-id="element-85" data-mp="3cyd3zgs4mjh6">
      <div className="max-w-3xl mx-auto flex flex-col items-center text-center" data-id="element-86" data-mp="3cz4u4c2yfp02">
        {/* Top divider */}
        <div className="w-16 h-px bg-zinc-200" data-id="element-87" data-mp="385a4ks0o4ft2" />

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 1,
        ease: 'easeOut'
      }} className="py-16 md:py-20" data-id="element-88" data-mp="337ie82fo91qz">
          <span className="block font-mono text-[11px] md:text-xs uppercase tracking-[0.35em] text-zinc-400 mb-8" data-id="element-89" data-mp="2kapjs2urpuv2">
            Bienvenidos
          </span>

          <h2 className="font-heading text-3xl md:text-5xl lg:text-6xl font-light uppercase tracking-tight leading-[1.1] text-zinc-900" data-id="element-90" data-mp="iib3t9bsb0ha">
            Una nueva experiencia
            <br className="hidden md:block" data-id="element-91" data-mp="39pnitlobb1b0" /> está en camino
          </h2>

          <p className="mt-10 text-lg md:text-xl font-light leading-relaxed text-zinc-500 max-w-2xl mx-auto" data-id="element-92" data-mp="3dtbp8117jquo">
            Mientras finalizamos nuestra nueva plataforma, aquí encontrarás
            nuestras próximas expediciones y programas de formación disponibles.
          </p>
        </motion.div>

        {/* Bottom divider */}
        <div className="w-16 h-px bg-zinc-200" data-id="element-93" data-mp="3sjj8uk2ybfwy" />
      </div>
    </section>;
}